<template>
    <div>
      <head-top :navActive="navActive"></head-top>
      <!-- 内容 start -->
      <div class="description-first-bg"></div>
      <div class="flow-path">
       <div v-for="item in innerHtmlList" :key="item.id">
         <div v-html=""></div>
       </div>
      </div>
      <!-- 内容 end -->
      <foot-bottom></foot-bottom>
    </div>
</template>

<script>
  import headTop from '../components/header/head-top'
  import footBottom from '../components/footer/foot-bottom'
  import tool from '../assets/js/tool.js'
  export default {
    name: "description-second",
    data () {
      return {
        navActive: 1,
        innerHtmlList:'', //接收数据数组
      }
    },
    components: {
      headTop,
      footBottom,
    },
    mounted () {
      let data = {
        type: 2,
        category_id: this.$route.query.id
      };
      tool.postData('get_system_list',data,(res) => {
        this.innerHtmlList = res.data.data.information_list;
      });
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/style/common";
  .description-first-bg{
    width: 100%;
    height: 80px;
    background: url("../../static/img/nav.png");
  }
  .flow-path{
    width: $box-width;
    height: 483px;
    margin: 0 auto;
    padding-top: 50px;
    box-sizing: border-box;
    p{
      @include font(16px,#3b3b3b);
      line-height: 40px;
      &.little-txt{
        margin-left: 57px;
      }
      span{
        color: #e23e04
      }
      a{
        color: #3b6bda;
        cursor: pointer;
        &:hover{
          text-decoration: underline;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/description-second.vue